export const OrderTypes = {
  BUNDLE_FTTH: 'bundle_ftth',
  BUNDLE_OTT: "bundle_ott",
  BUNDLE_POST_OTT: "bundle_post_ott",
  TELCO: "telco",
  ACCESSORY: "accessory",
  COMPLEX: "complex_pa",
  P2PDJ: "p2p_dj",
};

export type OrderTypeKeys = keyof typeof OrderTypes;
export type OrderTypeValue = typeof OrderTypes[OrderTypeKeys];
